module.exports = __webpack_public_path__ + "img/no-date@2x.1fcb12db.png";